module.exports = __webpack_public_path__ + "static/media/calendar.d42138f2.svg";